// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.articlePageWrapper__M_Jjb {
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  height: 100%;

  background: white;
}

.articlePageHeader__RMQUG {
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  padding: 20px 20px 16px;
}

.articlePageHeader__RMQUG div {
  transform: rotate(180deg);
  display: flex;
  align-items: center;
}

.articlePageHeader__RMQUG span {
  overflow: hidden;

  margin-left: 15px;

  text-wrap: balance;
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
  color: #262732;
}

.articleContent__StvYM {
  overflow-y: auto;

  max-width: 100%;
  padding: 0 20px;

  font-size: 14px;
  line-height: 22px;
  color: #262732;
}

.articleContent__StvYM img {
  max-width: 100%;
  border-radius: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/components/KnowledgeBase/ArticlePage/ArticlePage.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;;EAE3B,YAAY;;EAEZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;;EAEf,aAAa;EACb,mBAAmB;EACnB,2BAA2B;;EAE3B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;;EAEhB,iBAAiB;;EAEjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;;EAEhB,eAAe;EACf,eAAe;;EAEf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".articlePageWrapper {\n  overflow-x: hidden;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n\n  height: 100%;\n\n  background: white;\n}\n\n.articlePageHeader {\n  cursor: pointer;\n\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n\n  padding: 20px 20px 16px;\n}\n\n.articlePageHeader div {\n  transform: rotate(180deg);\n  display: flex;\n  align-items: center;\n}\n\n.articlePageHeader span {\n  overflow: hidden;\n\n  margin-left: 15px;\n\n  text-wrap: balance;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 22px;\n  color: #262732;\n}\n\n.articleContent {\n  overflow-y: auto;\n\n  max-width: 100%;\n  padding: 0 20px;\n\n  font-size: 14px;\n  line-height: 22px;\n  color: #262732;\n}\n\n.articleContent img {\n  max-width: 100%;\n  border-radius: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
export var articlePageWrapper = `articlePageWrapper__M_Jjb`;
export var articlePageHeader = `articlePageHeader__RMQUG`;
export var articleContent = `articleContent__StvYM`;
export default ___CSS_LOADER_EXPORT___;
